import { render, staticRenderFns } from "./ModalCredits.vue?vue&type=template&id=39fee15b&scoped=true&"
import script from "./ModalCredits.vue?vue&type=script&lang=js&"
export * from "./ModalCredits.vue?vue&type=script&lang=js&"
import style0 from "./ModalCredits.vue?vue&type=style&index=0&id=39fee15b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fee15b",
  null
  
)

export default component.exports